import SearchRecord from './SearchRecord.jsx';

// صفحة السجلّ التي يفتحها البحث العام. لا تظهر في القائمة الجانبية
// (sidebar: null) — يُوصل إليها من نتائج البحث فقط.
// لا نضع هنا مفتاح صلاحية: الخادم هو من يفرض صلاحية كل نوع سجل ويعيد رسالة
// عربية واضحة، فلا تتكرّر قائمة الصلاحيات في مكانين ولا تختلف بينهما.
export default {
  path: '/search/:type/:id',
  element: <SearchRecord />,
  protected: true,
  permission: null,
  standalone: false,
  sidebar: null
};
